/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { EDIT_SOFTSKILL_COURSE } from "./actionTypes"
import { editSoftskillCourseError, editSoftskillCourseSuccess } from "./actions"

//Include Both Helper File with needed methods
import { updateSoftskillsCourse } from "../../../helpers/backend_helper"

function* edit(action) {
  try {
    const response = yield call(updateSoftskillsCourse, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (!response.courseId) throw new Error("Error al guardar al cliente")
    yield put(editSoftskillCourseSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(editSoftskillCourseError(error.message))
  }
}

function* softskillCourseEditSaga() {
  yield takeEvery(EDIT_SOFTSKILL_COURSE, edit)
}

export default softskillCourseEditSaga
